import {StateInterface} from "../DAL/store";

export const deepLinkInit = (state: StateInterface) => {

    // deep link
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const props = ['pt', 'item-id', 'banner-id'];


    for(let i=0; i<props.length; i++){
        const prop = props[i];

        if(urlParams.has(prop)){
            state[prop] = urlParams.get(prop);
        }

    }
};
/**
 * Generate deep link
 * Example: https://dev.waves.com/specials#sort:path~type~order=.hidden-price~number~desc|views:view=grid-view|paging:currentPage=0|paging:number=60
 * sortType - text|number|datetime
 * sortOrder - asc|desc
 * layoutMode - grid|list
 */
export const generateDeepLink = (
    pageType: string,
    itemId: string,
    bannerId:string
    ) => {

    const parts = [];

    // pageType
    if(pageType !== undefined && pageType !== ''){
        parts.push(`pt=${pageType}`);
    }

    // itemId
    if(itemId !== undefined && itemId !== ''){
        parts.push(`item-id=${itemId}`);
    }
    //bannerId
    if(bannerId !== undefined && bannerId !== ''){
        parts.push(`banner-id=${bannerId}`);
    }
    return parts.join('|');
};
/**
 * update deep link -> replace it in URL
 */
export const updateDeepLink = (deepLink: string, hashStart: string = '#') => {

    let hashStr = deepLink.replace(hashStart, '').trim();

    if(hashStr === ''){
        hashStr = hashStart;
    }
    else{
        hashStr = hashStart + hashStr;
    }

    if(window.location.hash !== hashStr){

        const index = window.location.href.indexOf(hashStart);
        let href;

        if(index === -1){
            href = window.location.href + hashStr;
        }
        else{
            href = window.location.href.substring(0, index) + hashStr;
        }

        if('replaceState' in window.history){
            window.history.replaceState({}, '', href);
        }
        else{
            window.location.replace(href);
        }
    }
};
/**
 * Apply layout.
 */
/*
const applyLayout = (selectedLayout: string) => {

    dispatch(
        rootActions.refreshDeepLink({
            PageType: "banner"
        })
    );
};*/
/*
const applyLayout = (selectedLayout: string) => {

    dispatch(
        rootActions.refreshDeepLink({
            PageType: "banner"
        })
    );
};*/
